import React from 'react';
import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { CLASS_ENTITY_TYPE } from 'constants/logic';
import { disableClassMessages, disableServiceMessages } from './DisableClassConfirmationModal.messages';

const MESSAGES_BY_ENTITY_TYPE = {
  [CLASS_ENTITY_TYPE.CLASS]: disableClassMessages,
  [CLASS_ENTITY_TYPE.APPOINTMENT]: disableServiceMessages,
};

const DisableClassConfirmationModal = ({ classTitle, entityType = CLASS_ENTITY_TYPE.CLASS, numberOfReservations }) => {
  const messages = MESSAGES_BY_ENTITY_TYPE[entityType];

  return (
    <Confirm
      title={
        <Message
          message={!numberOfReservations ? messages.title : messages.titleWithReservations}
          values={{ classTitle, numberOfReservations }}
        />
      }
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.accept} />}
      isOpen>
      <Message
        message={messages.body}
        values={{
          strong: text => <strong>{text}</strong>,
        }}
      />
    </Confirm>
  );
};

DisableClassConfirmationModal.propTypes = {
  classTitle: PropTypes.string,
  entityType: PropTypes.oneOf(Object.values(CLASS_ENTITY_TYPE)),
  numberOfReservations: PropTypes.number,
};

export default DisableClassConfirmationModal;
